import { icons } from "./icons";

export const statusIcons: any = {
  white: icons.received,
  orange: icons.receivedPrimary,
  grey: icons.receivedGrey,
};
